import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatMenuTrigger } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../services/login.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Observable } from 'rxjs';
import { EncryptDecryptService } from '../services/encrypt-decrypt.service';
import { NotificationService } from '../services/notification.service';
import { AccidentService } from '../services/accident.service'
import { ForgotpasswordComponent } from '../forgotpassword/forgotpassword.component';
import { config } from '../config';
// import{}
declare var $;


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  activeRouteName: any;
  user: any;
  msg: string = null;
  errmsg: string = null;
  show: boolean;
  pwd: boolean;
  returnUrl;
  loading: boolean = false
  message
  isPolicy: boolean = false
  isAdminPolicy: boolean = false
  loginModel: boolean = false
  loading1: boolean = false
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public _EncryptDecryptService: EncryptDecryptService,
    public route: Router,
    public dialog: MatDialog,
    public _loginService: LoginService,
    public router: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service,
    private notificationService: NotificationService,
    public accidentService: AccidentService,
    public dialogRef: MatDialogRef<any>,
  ) {
    dialogRef.disableClose = true;
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required)
    });

    // if (!localStorage.getItem('userRoles')) {
    //   this._loginService.logout()
    console.log("WHAT IS IN THE DATA", this.data);

    if (this.data.loginModel) this.loginModel = true
    if (!this.loginModel) this._loginService.removeUser()
    // }

    // else if (this._loginService.currentUserValue) {

    //   this.route.navigate(['/dashboard']);
    // }

  }

  ngOnInit() {
    // this.loading = true
    this.router.params.subscribe(param => {
      console.log("param in login in superAdmin Route", param)
      this.activeRouteName = param.user;
      // if (param.superAdmin) {
      // this.setSuperAdmin(param.superAdmin)
      // }
    });

    this.router.queryParams.subscribe(qparam => {
      console.log("================qparam in login in superAdmin Route===========", qparam)
      this.setSuperAdmin(qparam.superAdmin)
    })

    this.returnUrl = this.router.snapshot.queryParams['returnUrl'];

    // let previousUrl = window.history.state.prevUrl

    console.log('this.returnUrl In Login', this.returnUrl, window.history);

    $(".toggle-password").click(function () {
      $(this).toggleClass("fa-eye fa-eye-slash");
    });

    $(".main").css({ 'padding': '100px 20px 20px' });
  }

  validate(data) {
    console.log("Validating ", data);
    if (!data.email) return false;
    if (!data.password) return false;
    return true;
  }

  openDialog(someComponent, data = { user: this.activeRouteName }): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }
  close() {
    this.dialogRef.close()
  }

  // MODALS
  forgotPasswordModal() {

    let temp = this.route.url.split('/')
    if (temp.length == 3) {
      this.activeRouteName = 'admin'
    }
    else {
      this.activeRouteName = 'user'
    }
    var addedClient = this.openDialog(ForgotpasswordComponent).subscribe((client) => {
      console.log("Client added in controller = ", client);
      if (client == undefined) return;
    });

  }

  password() {
    this.show = !this.show;
    this.pwd = !this.pwd;
  }
  updatePassword() {
    console.log("update the password policy");
    if (this.isAdminPolicy) {
      this.route.navigate(['resetpassword'], { queryParams: { password: true, admin: true } });
    } else {
      this.route.navigate(['resetpassword'], { queryParams: { password: true } });
    }
  }

  redirectSponsorPack() {
    // this.route.navigate(['sponsor-pack'], { queryParams: { _isSponsor: true } });
    let url = config.clientUrl + 'sponsor-pack/' + '?_isSponsor=true'
    window.open(url)
  }




  doSubmit() {

    // this.router.params.subscribe(param => {
    //   console.log('param', param)
    //   this.activeRouteName = param.user;
    // });

    console.log(this.route.url, "this.route.url")
    let temp;
    if (this.loginModel) {
      this.user = JSON.parse(localStorage.getItem('userRoles'));
      console.log("this.user", this.user);
      if (this.user.isAdmin) {
        this.activeRouteName = 'admin'
      }
      else {
        this.activeRouteName = 'user'
      }
    } else {
      temp = this.route.url.split('/')
      if (temp.length == 3) {
        this.activeRouteName = 'admin'
      }
      else {
        this.activeRouteName = 'user'
      }
    }

    console.log(' this.activeRouteName:', this.activeRouteName);

    if (this.loginForm.valid) {
      if (!this.loginModel) this.loading = true;
      else if (this.loginModel) this.loading1 = true

      let loginDetails = {
        email: this.loginForm.value.email,
        password: this._EncryptDecryptService.encrypt(this.loginForm.value.password)
      }

      this.recaptchaV3Service.execute('importantAction').subscribe((token) => {
        this._loginService.login(loginDetails, this.activeRouteName, token).subscribe(data => {
          console.log("data of login user", data);
          if (!this.loginModel) this.loading = false;
          else if (this.loginModel) this.loading1 = false
          this._loginService.sendLoggedInUserToAppUser(data)
          console.log("getting item", JSON.parse(localStorage.getItem('currentUser')))
          let currentLoggedIn = JSON.parse(localStorage.getItem('currentUser'))
          // let user = JSON.parse(localStorage.getItem('userRoles'))
          const user = this._loginService.userRolesValue;
          let msgObj = {}
          if (user.isAdmin) {
            msgObj['userId'] = currentLoggedIn._id,
              msgObj['onModel'] = 'admin'
          } else {
            msgObj['userId'] = currentLoggedIn.userId,
              msgObj['onModel'] = 'user'
          }
          this.notificationService.requestPermission(msgObj)

          // this.notificationService.receiveMessage()
          // this.message = this.notificationService.currentMessage
          // console.log("login success resonse:", temp);
          $(".main").removeAttr('style');

          $(document).ready(function () {
            $(".sidebar").show()
            $("#topnav").show()
            $(".sidebar").toggleClass('sidebar--Collapse')
          });

          const learnerDashBoard = '/learner/view/' + data._id;
          const clientDashboard = '/client/view/' + data._id;
          console.log("Here is the return url", user);

          if (this.returnUrl != null) {
            this.route.navigateByUrl(this.returnUrl);
          } else if (!this.loginModel) {
            this.notificationService.totalCounts().subscribe((data) => {
              console.log("find data", data)
            }, err => {
              console.log("find error")
            })
            if (user.isAdmin || user.isManager) this.route.navigate(['/dashboard']);
            else if (user.isTrainer || user.isMp || user.isIQA || user.isOperative) {
              console.log("this is data of only staff", data);
              this.accidentService.displayAccidentTab({ isAccident: data.isAccident })
              this.route.navigate(['/scheduler/view']);
              // this.route.navigate(['/trainerLogin']);
            }
            else if (user.isAssetManager) {
              console.log("CALL THIS FUNCTION FOR ASSET MANAGER ", data)
              this.route.navigate(['/staff/view/' + data._id])
            }
            else if (user.isClient) this.route.navigate([clientDashboard]);
            else if (user.isLearner) {
              if (currentLoggedIn.jobs && currentLoggedIn.jobs[0]._id) {
                this.route.navigate([learnerDashBoard], { queryParams: { job: currentLoggedIn.jobs[0]._id } });
              } else {
                this.route.navigate(['/server-error'])
              }
            } else if (user.isStaff) this.route.navigate(['/week-list']);
            else if (user.isIncidentUser) this.route.navigate(['/staff/' + data._id])
            // else if (user.isOperative) this.route.navigate(['/staff/' + data._id])
          }
          else {
            this.dialogRef.close();
          }

          $(document).ready(function () {
            $(".sidebar").toggleClass('sidebar--Collapse')
          });
        }, err => {
          if (!this.loginModel) this.loading = false;
          else if (this.loginModel) this.loading1 = false
          console.log('error while login', err);
          // if(err.status === 0){
          //   this.route.navigate(['/server-error',{maintenance:'maintenance'}])
          // }
          if (err && err.error && err.error.isAdmin) {
            this.isAdminPolicy = err.error.isAdmin
            console.log("Hello Here Is Admin===>", this.isAdminPolicy)
          }

          if (err.status === 405) {
            this.isPolicy = true
          }
          if (this.loginModel) this.errmsg = err.message;
          else this.errmsg = err.error.message;
        });
      })
    } else {
      console.log('Login form is not valid!!');
    }
  }

  setSuperAdmin(superAdmin) {
    console.log("super admin data", superAdmin);

    if (superAdmin && superAdmin != undefined) {


      this._loginService.superAdmin(superAdmin)
      // let roles = {
      //   isAdmin: true
      // };
      // // roles['isAdmin'] = true
      // // let temp = JSON.parse(superAdmin)
      // localStorage.setItem('token', JSON.parse(superAdmin).token)
      // localStorage.setItem('currentUser', JSON.parse(superAdmin).user);
      // localStorage.setItem('userRoles', JSON.stringify(roles))
      // console.log("superAdminsuperAdmin-----------------------------------", JSON.parse(superAdmin))
      // this.route.navigate(['']);
    }
  }

}
